module.exports = __webpack_public_path__ + "static/img/client_background_mobile.a62d2fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client_background_mobile.png
// module id = mF6t
// module chunks = 1